 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_TALLYHO_FRONTCOVER from '@/components/01_TallyHo_frontcover'
 import A2_TALLYHO_TITLE from '@/components/02_TallyHo_title'
 import A3_TALLYHO_COPYRIGHT from '@/components/03_TallyHo_copyright'
 import A4_1_TALLYHO_TOC from '@/components/04_1_TallyHo_toc'
 import A4_TALLYHO_PLATES1 from '@/components/04_TallyHo_plates1'
 import A4_TALLYHO_PLATES2 from '@/components/04_TallyHo_plates2'
 import A4_TALLYHO_PLATES3 from '@/components/04_TallyHo_plates3'
 import A4_TALLYHO_PLATES4 from '@/components/04_TallyHo_plates4'
 import A4_TALLYHO_PLATES5 from '@/components/04_TallyHo_plates5'
 import A4_TALLYHO_PLATES6 from '@/components/04_TallyHo_plates6'
 import A4_TALLYHO_PLATES7 from '@/components/04_TallyHo_plates7'
 import A4_TALLYHO_PLATES8 from '@/components/04_TallyHo_plates8'
 import A4_TALLYHO_PLATES9 from '@/components/04_TallyHo_plates9'
 import A4_TALLYHO_PLATES10 from '@/components/04_TallyHo_plates10'
 import A4_TALLYHO_PLATES11 from '@/components/04_TallyHo_plates11'
 import A4_TALLYHO_PLATES12 from '@/components/04_TallyHo_plates12'
 import A4_TALLYHO_PLATES13 from '@/components/04_TallyHo_plates13'
 import A4_TALLYHO_PLATES14 from '@/components/04_TallyHo_plates14'
 import A4_TALLYHO_PLATES15 from '@/components/04_TallyHo_plates15'
 import A4_TALLYHO_PLATES16 from '@/components/04_TallyHo_plates16'
 import A4_TALLYHO_PLATES17 from '@/components/04_TallyHo_plates17'
 import A4_TALLYHO_PLATES18 from '@/components/04_TallyHo_plates18'
 import A4_TALLYHO_PLATES19 from '@/components/04_TallyHo_plates19'
 import A4_TALLYHO_PLATES20 from '@/components/04_TallyHo_plates20'
 import A4_TALLYHO_PLATES21 from '@/components/04_TallyHo_plates21'
 import A4_TALLYHO_PLATES22 from '@/components/04_TallyHo_plates22'
 import A4_TALLYHO_PLATES23 from '@/components/04_TallyHo_plates23'
 import A4_TALLYHO_PLATES24 from '@/components/04_TallyHo_plates24'
 import A4_TALLYHO_PLATES25 from '@/components/04_TallyHo_plates25'
 import A4_TALLYHO_PLATES26 from '@/components/04_TallyHo_plates26'
 import A4_TALLYHO_PLATES27 from '@/components/04_TallyHo_plates27'
 import A4_TALLYHO_PLATES28 from '@/components/04_TallyHo_plates28'
 import A4_TALLYHO_PLATES29 from '@/components/04_TallyHo_plates29'
 import A4_TALLYHO_PLATES30 from '@/components/04_TallyHo_plates30'
 import A4_TALLYHO_PLATES31 from '@/components/04_TallyHo_plates31'
 import A4_TALLYHO_PLATES32 from '@/components/04_TallyHo_plates32'
 import A4_TALLYHO_PLATES33 from '@/components/04_TallyHo_plates33'
 import A4_TALLYHO_PLATES34 from '@/components/04_TallyHo_plates34'
 import A4_TALLYHO_PLATES35 from '@/components/04_TallyHo_plates35'
 import A4_TALLYHO_PLATES36 from '@/components/04_TallyHo_plates36'
 import A4_TALLYHO_PLATES37 from '@/components/04_TallyHo_plates37'
 import A4_TALLYHO_PLATES38 from '@/components/04_TallyHo_plates38'
 import A4_TALLYHO_PLATES39 from '@/components/04_TallyHo_plates39'
 import A4_TALLYHO_PLATES40 from '@/components/04_TallyHo_plates40'
 import A4_TALLYHO_PLATES41 from '@/components/04_TallyHo_plates41'
 import A4_TALLYHO_PLATES42 from '@/components/04_TallyHo_plates42'
 import A4_TALLYHO_PLATES43 from '@/components/04_TallyHo_plates43'
 import A4_TALLYHO_PLATES44 from '@/components/04_TallyHo_plates44'
 import A4_TALLYHO_PLATES45 from '@/components/04_TallyHo_plates45'
 import A4_TALLYHO_PLATES46 from '@/components/04_TallyHo_plates46'
 import A4_TALLYHO_PLATES47 from '@/components/04_TallyHo_plates47'
 import A5_TALLYHO_ACKNOWLEDGMENT from '@/components/05_TallyHo_acknowledgment'
 import A3A_TALLYHO_PROLOGUE from '@/components/03a_TallyHo_Prologue'
 import A6_TALLYHO_CH01 from '@/components/06_TallyHo_ch01'
 import A7_TALLYHO_CH011 from '@/components/07_TallyHo_ch01-1'
 import A8_TALLYHO_CH012 from '@/components/08_TallyHo_ch01-2'
 import A9_TALLYHO_CH013 from '@/components/09_TallyHo_ch01-3'
 import A0_TALLYHO_CH014 from '@/components/10_TallyHo_ch01-4'
 import A1_TALLYHO_CH02 from '@/components/11_TallyHo_ch02'
 import A2_TALLYHO_CH021 from '@/components/12_TallyHo_ch02-1'
 import A3_TALLYHO_CH023 from '@/components/13_TallyHo_ch02-3'
 import A4_TALLYHO_CH03 from '@/components/14_TallyHo_ch03'
 import A5_TALLYHO_CH031 from '@/components/15_TallyHo_ch03-1'
 import A6_TALLYHO_CH032 from '@/components/16_TallyHo_ch03-2'
 import A7_TALLYHO_CH04 from '@/components/17_TallyHo_ch04'
 import A8_TALLYHO_CH041 from '@/components/18_TallyHo_ch04-1'
 import A9_TALLYHO_CH042 from '@/components/19_TallyHo_ch04-2'
 import A0_TALLYHO_CH05 from '@/components/20_TallyHo_ch05'
 import A1_TALLYHO_CH06 from '@/components/21_TallyHo_ch06'
 import A2_TALLYHO_CH061 from '@/components/22_TallyHo_ch06-1'
 import A3_TALLYHO_CH062 from '@/components/23_TallyHo_ch06-2'
 import A4_TALLYHO_CH07 from '@/components/24_TallyHo_ch07'
 import A5_TALLYHO_CH071 from '@/components/25_TallyHo_ch07-1'
 import A6_TALLYHO_CH072 from '@/components/26_TallyHo_ch07-2'
 import A7_TALLYHO_CH073 from '@/components/27_TallyHo_ch07-3'
 import A8_TALLYHO_CH074 from '@/components/28_TallyHo_ch07-4'
 import A9_TALLYHO_CH08 from '@/components/29_TallyHo_ch08'
 import A0_TALLYHO_CH081 from '@/components/30_TallyHo_ch08-1'
 import A1_TALLYHO_CH082 from '@/components/31_TallyHo_ch08-2'
 import A2_TALLYHO_CH083 from '@/components/32_TallyHo_ch08-3'
 import A2A_TALLYHO_CH084 from '@/components/32a_TallyHo_ch08-4'
 import A3_TALLYHO_CH085 from '@/components/33_TallyHo_ch08-5'
 import A4_TALLYHO_CH086 from '@/components/34_TallyHo_ch08-6'
 import A5_TALLYHO_CH09 from '@/components/35_TallyHo_ch09'
 import A6_TALLYHO_CH10 from '@/components/36_TallyHo_ch10'
 import A7_TALLYHO_CH101 from '@/components/37_TallyHo_ch10-1'
 import A8_TALLYHO_CH102 from '@/components/38_TallyHo_ch10-2'
 import A9_TALLYHO_CH11 from '@/components/39_TallyHo_ch11'
 import A0_TALLYHO_CH12 from '@/components/40_TallyHo_ch12'
 import A1_TALLYHO_EPILOGUE from '@/components/41_TallyHo_Epilogue'
 import A2_TALLYHO_EPILOGUE1 from '@/components/42_TallyHo_Epilogue-1'
 import A3_TALLYHO_EPILOGUE2 from '@/components/43_TallyHo_Epilogue-2'
 import A4_TALLYHO_APPENDIX from '@/components/44_TallyHo_Appendix'
 import A5_TALLYHO_BIBLIOGRAPHY from '@/components/45_TallyHo_Bibliography'
 import A6_TALLYHO_NOTES from '@/components/46_TallyHo_notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/01_TallyHo_frontcover",
 			"name" : "01_TallyHo_frontcover",
 			"component" : A1_TALLYHO_FRONTCOVER
 		},
 		{
 			"path" : "/02_TallyHo_title",
 			"name" : "02_TallyHo_title",
 			"component" : A2_TALLYHO_TITLE
 		},
 		{
 			"path" : "/03_TallyHo_copyright",
 			"name" : "03_TallyHo_copyright",
 			"component" : A3_TALLYHO_COPYRIGHT
 		},
 		{
 			"path" : "/04_1_TallyHo_toc",
 			"name" : "04_1_TallyHo_toc",
 			"component" : A4_1_TALLYHO_TOC
 		},
 		{
 			"path" : "/04_TallyHo_plates1",
 			"name" : "04_TallyHo_plates1",
 			"component" : A4_TALLYHO_PLATES1
 		},
 		{
 			"path" : "/04_TallyHo_plates2",
 			"name" : "04_TallyHo_plates2",
 			"component" : A4_TALLYHO_PLATES2
 		},
 		{
 			"path" : "/04_TallyHo_plates3",
 			"name" : "04_TallyHo_plates3",
 			"component" : A4_TALLYHO_PLATES3
 		},
 		{
 			"path" : "/04_TallyHo_plates4",
 			"name" : "04_TallyHo_plates4",
 			"component" : A4_TALLYHO_PLATES4
 		},
 		{
 			"path" : "/04_TallyHo_plates5",
 			"name" : "04_TallyHo_plates5",
 			"component" : A4_TALLYHO_PLATES5
 		},
 		{
 			"path" : "/04_TallyHo_plates6",
 			"name" : "04_TallyHo_plates6",
 			"component" : A4_TALLYHO_PLATES6
 		},
 		{
 			"path" : "/04_TallyHo_plates7",
 			"name" : "04_TallyHo_plates7",
 			"component" : A4_TALLYHO_PLATES7
 		},
 		{
 			"path" : "/04_TallyHo_plates8",
 			"name" : "04_TallyHo_plates8",
 			"component" : A4_TALLYHO_PLATES8
 		},
 		{
 			"path" : "/04_TallyHo_plates9",
 			"name" : "04_TallyHo_plates9",
 			"component" : A4_TALLYHO_PLATES9
 		},
 		{
 			"path" : "/04_TallyHo_plates10",
 			"name" : "04_TallyHo_plates10",
 			"component" : A4_TALLYHO_PLATES10
 		},
 		{
 			"path" : "/04_TallyHo_plates11",
 			"name" : "04_TallyHo_plates11",
 			"component" : A4_TALLYHO_PLATES11
 		},
 		{
 			"path" : "/04_TallyHo_plates12",
 			"name" : "04_TallyHo_plates12",
 			"component" : A4_TALLYHO_PLATES12
 		},
 		{
 			"path" : "/04_TallyHo_plates13",
 			"name" : "04_TallyHo_plates13",
 			"component" : A4_TALLYHO_PLATES13
 		},
 		{
 			"path" : "/04_TallyHo_plates14",
 			"name" : "04_TallyHo_plates14",
 			"component" : A4_TALLYHO_PLATES14
 		},
 		{
 			"path" : "/04_TallyHo_plates15",
 			"name" : "04_TallyHo_plates15",
 			"component" : A4_TALLYHO_PLATES15
 		},
 		{
 			"path" : "/04_TallyHo_plates16",
 			"name" : "04_TallyHo_plates16",
 			"component" : A4_TALLYHO_PLATES16
 		},
 		{
 			"path" : "/04_TallyHo_plates17",
 			"name" : "04_TallyHo_plates17",
 			"component" : A4_TALLYHO_PLATES17
 		},
 		{
 			"path" : "/04_TallyHo_plates18",
 			"name" : "04_TallyHo_plates18",
 			"component" : A4_TALLYHO_PLATES18
 		},
 		{
 			"path" : "/04_TallyHo_plates19",
 			"name" : "04_TallyHo_plates19",
 			"component" : A4_TALLYHO_PLATES19
 		},
 		{
 			"path" : "/04_TallyHo_plates20",
 			"name" : "04_TallyHo_plates20",
 			"component" : A4_TALLYHO_PLATES20
 		},
 		{
 			"path" : "/04_TallyHo_plates21",
 			"name" : "04_TallyHo_plates21",
 			"component" : A4_TALLYHO_PLATES21
 		},
 		{
 			"path" : "/04_TallyHo_plates22",
 			"name" : "04_TallyHo_plates22",
 			"component" : A4_TALLYHO_PLATES22
 		},
 		{
 			"path" : "/04_TallyHo_plates23",
 			"name" : "04_TallyHo_plates23",
 			"component" : A4_TALLYHO_PLATES23
 		},
 		{
 			"path" : "/04_TallyHo_plates24",
 			"name" : "04_TallyHo_plates24",
 			"component" : A4_TALLYHO_PLATES24
 		},
 		{
 			"path" : "/04_TallyHo_plates25",
 			"name" : "04_TallyHo_plates25",
 			"component" : A4_TALLYHO_PLATES25
 		},
 		{
 			"path" : "/04_TallyHo_plates26",
 			"name" : "04_TallyHo_plates26",
 			"component" : A4_TALLYHO_PLATES26
 		},
 		{
 			"path" : "/04_TallyHo_plates27",
 			"name" : "04_TallyHo_plates27",
 			"component" : A4_TALLYHO_PLATES27
 		},
 		{
 			"path" : "/04_TallyHo_plates28",
 			"name" : "04_TallyHo_plates28",
 			"component" : A4_TALLYHO_PLATES28
 		},
 		{
 			"path" : "/04_TallyHo_plates29",
 			"name" : "04_TallyHo_plates29",
 			"component" : A4_TALLYHO_PLATES29
 		},
 		{
 			"path" : "/04_TallyHo_plates30",
 			"name" : "04_TallyHo_plates30",
 			"component" : A4_TALLYHO_PLATES30
 		},
 		{
 			"path" : "/04_TallyHo_plates31",
 			"name" : "04_TallyHo_plates31",
 			"component" : A4_TALLYHO_PLATES31
 		},
 		{
 			"path" : "/04_TallyHo_plates32",
 			"name" : "04_TallyHo_plates32",
 			"component" : A4_TALLYHO_PLATES32
 		},
 		{
 			"path" : "/04_TallyHo_plates33",
 			"name" : "04_TallyHo_plates33",
 			"component" : A4_TALLYHO_PLATES33
 		},
 		{
 			"path" : "/04_TallyHo_plates34",
 			"name" : "04_TallyHo_plates34",
 			"component" : A4_TALLYHO_PLATES34
 		},
 		{
 			"path" : "/04_TallyHo_plates35",
 			"name" : "04_TallyHo_plates35",
 			"component" : A4_TALLYHO_PLATES35
 		},
 		{
 			"path" : "/04_TallyHo_plates36",
 			"name" : "04_TallyHo_plates36",
 			"component" : A4_TALLYHO_PLATES36
 		},
 		{
 			"path" : "/04_TallyHo_plates37",
 			"name" : "04_TallyHo_plates37",
 			"component" : A4_TALLYHO_PLATES37
 		},
 		{
 			"path" : "/04_TallyHo_plates38",
 			"name" : "04_TallyHo_plates38",
 			"component" : A4_TALLYHO_PLATES38
 		},
 		{
 			"path" : "/04_TallyHo_plates39",
 			"name" : "04_TallyHo_plates39",
 			"component" : A4_TALLYHO_PLATES39
 		},
 		{
 			"path" : "/04_TallyHo_plates40",
 			"name" : "04_TallyHo_plates40",
 			"component" : A4_TALLYHO_PLATES40
 		},
 		{
 			"path" : "/04_TallyHo_plates41",
 			"name" : "04_TallyHo_plates41",
 			"component" : A4_TALLYHO_PLATES41
 		},
 		{
 			"path" : "/04_TallyHo_plates42",
 			"name" : "04_TallyHo_plates42",
 			"component" : A4_TALLYHO_PLATES42
 		},
 		{
 			"path" : "/04_TallyHo_plates43",
 			"name" : "04_TallyHo_plates43",
 			"component" : A4_TALLYHO_PLATES43
 		},
 		{
 			"path" : "/04_TallyHo_plates44",
 			"name" : "04_TallyHo_plates44",
 			"component" : A4_TALLYHO_PLATES44
 		},
 		{
 			"path" : "/04_TallyHo_plates45",
 			"name" : "04_TallyHo_plates45",
 			"component" : A4_TALLYHO_PLATES45
 		},
 		{
 			"path" : "/04_TallyHo_plates46",
 			"name" : "04_TallyHo_plates46",
 			"component" : A4_TALLYHO_PLATES46
 		},
 		{
 			"path" : "/04_TallyHo_plates47",
 			"name" : "04_TallyHo_plates47",
 			"component" : A4_TALLYHO_PLATES47
 		},
 		{
 			"path" : "/05_TallyHo_acknowledgment",
 			"name" : "05_TallyHo_acknowledgment",
 			"component" : A5_TALLYHO_ACKNOWLEDGMENT
 		},
 		{
 			"path" : "/03a_TallyHo_Prologue",
 			"name" : "03a_TallyHo_Prologue",
 			"component" : A3A_TALLYHO_PROLOGUE
 		},
 		{
 			"path" : "/06_TallyHo_ch01",
 			"name" : "06_TallyHo_ch01",
 			"component" : A6_TALLYHO_CH01
 		},
 		{
 			"path" : "/07_TallyHo_ch01-1",
 			"name" : "07_TallyHo_ch01-1",
 			"component" : A7_TALLYHO_CH011
 		},
 		{
 			"path" : "/08_TallyHo_ch01-2",
 			"name" : "08_TallyHo_ch01-2",
 			"component" : A8_TALLYHO_CH012
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js